import { CONSTANTS, NumberUtils } from '@pk/powerkioskutils';

export class ViewRfqSessionProduct {
	public rfqSessionProductId: string;
	public rfqSessionId: string;
	public productId: string;
	public productName: string;
	public serviceTypeId: string;
	public term: number;
	public greenPercentage: number;
	public todayBidCount: number;
	public todaySupplierParticipation: number;
	public enablePacking: boolean;
	public bestBidRate: number;
	public bestBidDate: Date;
	public currencySymbol: string;

	//Maps rate to dth or mwh
	public displayBidRate: number;
	public displayBidUnits: string;

	constructor(viewRfqSessionProduct?: ViewRfqSessionProduct) {
		Object.assign(this, viewRfqSessionProduct);

		if (this.serviceTypeId && this.bestBidRate) {
			this.displayBidUnits = this.serviceTypeId === CONSTANTS.serviceTypes.naturalGas.serviceTypeId ? 'dth' : 'MWh';
			this.displayBidRate = NumberUtils.rateToUnits(this.bestBidRate, this.displayBidUnits.toLowerCase());
		}
	}
}
